/**
 * Alertes d'erreur des écrans (Sentry), T4 — décisions du 2026-10-16 : erreurs seulement (ni suivi des performances,
 * ni enregistrement de session), utilisateur identifié par son identifiant interne seulement. Désactivé sans
 * `SENTRY_DSN` (local, CI, Jest). Réglages du serveur : backend/monitoring.py.
 */
import * as Sentry from '@sentry/react';
import { ENVIRONMENT, SENTRY_DSN } from '@/config';

let active = false;

/** Retire d'une erreur tout ce qui identifie la personne, sauf son identifiant interne. */
export function scrubEvent(event) {
  if (event.request) {
    delete event.request.cookies;
    delete event.request.data;
    delete event.request.headers;
  }
  if (event.user) event.user = event.user.id ? { id: event.user.id } : {};
  return event;
}

export function initMonitoring() {
  if (!SENTRY_DSN || active) return active;
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENVIRONMENT,
    sendDefaultPii: false,
    tracesSampleRate: 0,
    beforeSend: scrubEvent,
  });
  active = true;
  return active;
}

export function setMonitoringUser(id) {
  if (active) Sentry.setUser(id ? { id: String(id) } : null);
}

export function reportError(error, componentStack) {
  if (active) Sentry.captureException(error, { contexts: { react: { componentStack } } });
}
